<div id="todo" class="page-layout carded left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <div fxLayout="column" fxLayoutAlign="center start">
            <h1 class="titulo">{{'CONSULTAR_RT.TITULO' | translate }}</h1>
        </div>

        <div class="content-card">
            <div class="toolbar primary px-24 py-8">
                <span><h3 class="titulo_s">{{'CONSULTAR_RT.HEADER' | translate }}</h3></span>
            </div>

            <mat-form-field class="instituto" appearance="outline">
                <mat-label>{{'CONSULTAR_RT.INSTITUTOS' | translate }}</mat-label>
                <mat-select>
                    <mat-option *ngFor="let institutos of institutes" [value]="institutos.numInstituto" (click)="validarInstituto(institutos.numInstituto)">
                        {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institutos.numInstituto | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filtro" appearance="outline">
                <mat-label>{{'CONSULTAR_RT.FILTRO' | translate }}</mat-label>
                <input matInput matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'CONSULTAR_RT.SELECCIONFILTRO' | translate }}">
            </mat-form-field>

            <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
                <h1 class="textoC" *ngIf="cargando">{{'CONSULTAR_RT.CARGANDO' | translate }}</h1>
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" *ngIf="datosTabla && !cargando">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

  <ng-container matColumnDef="nombre_de_empresa">
    <th mat-header-cell *matHeaderCellDef> {{'CONSULTAR_RT.NOMBRE_DE_EMPRESA' | translate }} </th>
    <td mat-cell *matCellDef="let element"> {{element.datosEmpresa.nombreEmpresa}} </td>
  </ng-container>
  <ng-container matColumnDef="fecha">
    <th mat-header-cell *matHeaderCellDef>{{'CONSULTAR_RT.FECHA_DE_EMPRESA' | translate }}  </th>
    <td mat-cell *matCellDef="let element"> {{element.createdAt | date:'yyyy-MM-dd HH:mm:ss'}} </td>
  </ng-container>

  <ng-container matColumnDef="tipoProducto">
    <th mat-header-cell *matHeaderCellDef> {{'CONSULTAR_RT.PRODUCTO' | translate }} </th>
    <td mat-cell *matCellDef="let element"> {{'CONSULTAR_RT.PRODUCTOS.'+element.certificar.idProducto | translate}} </td>
  </ng-container>

  <ng-container matColumnDef="token">
    <th mat-header-cell *matHeaderCellDef> {{'CONSULTAR_RT.TOKEN' | translate }} </th>
    <td mat-cell *matCellDef="let element"> {{element.certificar.tokenConfig}} </td>
  </ng-container>
  <ng-container matColumnDef="estatus">
    <th mat-header-cell *matHeaderCellDef> {{'CONSULTAR_RT.ESTATUS' | translate }}</th>
    <td mat-cell *matCellDef="let element"> {{'CONSULTAR_RT.'+element.certificar.estatusReq | translate }}</td>
  </ng-container>

  <ng-container matColumnDef="accion">
    <th mat-header-cell *matHeaderCellDef> {{'CONSULTAR_RT.ACCIONES' | translate }} </th>
    <td mat-cell *matCellDef="let element">
      <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(element.certificar._id, element._id)">
        <mat-icon>playlist_add_check</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
  <!-- <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons style="margin-bottom: 250px; width:90%;"></mat-paginator> -->
        <mat-paginator class="tamaño" style-paginator  [pageSize]="20" showFirstLastButtons [showTotalPages]="3" [pageSizeOptions]="[20,50, 100, 500, 1000]" [length]="dataSource.data.length"></mat-paginator>
</div>
        </div>
    </div>
</div>
